"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDescription = addDescription;
exports.cleanRirString = cleanRirString;
exports.conditionalPromise = conditionalPromise;
exports.convertIsoToEurostatCountryCode = convertIsoToEurostatCountryCode;
exports.delayedPromise = delayedPromise;
exports.difference = difference;
exports.diversifySortByField = diversifySortByField;
exports.eventSummary = eventSummary;
exports.expandBgpAlert = expandBgpAlert;
exports.getBgpMonitoringGroup = getBgpMonitoringGroup;
exports.getCurrencySymbol = getCurrencySymbol;
exports.getFirst = getFirst;
exports.getGeofeedFileKey = getGeofeedFileKey;
exports.getGlobal = getGlobal;
exports.getLast = getLast;
exports.getNormalText = getNormalText;
exports.getNotificationUrl = getNotificationUrl;
exports.getPlanUpgradeUrl = getPlanUpgradeUrl;
exports.getSeverities = getSeverities;
exports.getSeverityText = getSeverityText;
exports.getVatPercentage = getVatPercentage;
exports.hashStringToInt = hashStringToInt;
exports.indexArray = indexArray;
exports.indexArrayDuplicates = indexArrayDuplicates;
exports.indexArrayValue = indexArrayValue;
exports.indexComponent = indexComponent;
exports.intersectArray = intersectArray;
exports.isPromise = isPromise;
exports.listCommas = listCommas;
exports.noFail = noFail;
exports.prefixPayloadCreation = prefixPayloadCreation;
exports.prependAsn = prependAsn;
exports.processSuspensionReasons = processSuspensionReasons;
exports.promisify = promisify;
exports.pruneDictionary = pruneDictionary;
exports.removeNullables = removeNullables;
exports.renderDate = renderDate;
exports.roaListToString = roaListToString;
exports.roundToDecimals = roundToDecimals;
exports.roundToSeconds = roundToSeconds;
exports.sanitizeString = sanitizeString;
exports.sanitizeStringAddUnderscore = sanitizeStringAddUnderscore;
exports.setDefaultSeverities = setDefaultSeverities;
exports.severityColors = void 0;
exports.splitArrayIntoChunks = splitArrayIntoChunks;
exports.sumArrayItems = sumArrayItems;
exports.summarizeBgpAlert = summarizeBgpAlert;
exports.toFirstLetterUppercase = toFirstLetterUppercase;
exports.toFirstUpperCase = toFirstUpperCase;
exports.toRange = toRange;
exports.unique = unique;
exports.uniqueDelayedPromise = uniqueDelayedPromise;
var _brembo = _interopRequireDefault(require("brembo"));
var _ipSub = _interopRequireDefault(require("ip-sub"));
var _md = _interopRequireDefault(require("md5"));
var _moment = _interopRequireDefault(require("moment"));
var _validationUtil = require("@wbr/validation-util");
var _netValidations = require("net-validations");
var _objectFingerprint = _interopRequireDefault(require("object-fingerprint"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var severityColors = exports.severityColors = {
  critical: "#941a00",
  high: "#f56341",
  medium: "#f19b55",
  low: "#a9a9a9"
};
var severities = ["low", "medium", "high", "critical"];
function getCurrencySymbol(currency) {
  return _validationUtil.currencies[currency];
}
function setDefaultSeverities(defaultSeverities, userSeverities) {
  var severities = _objectSpread({}, defaultSeverities);
  var _iterator = _createForOfIteratorHelper(userSeverities),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var severity = _step.value;
      severities[severity.name] = severity.value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return severities;
}
function sanitizeString(str) {
  var regex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /[^A-Za-z0-9-]/g;
  return str.replace(regex, "");
}
function sanitizeStringAddUnderscore(str) {
  return sanitizeString(str.replaceAll(" ", "_"), /[^A-Za-z0-9_]/g);
}
function listCommas(list) {
  if (list.length === 1) {
    return list;
  }
  return list.slice(0, list.length - 1).map(function (i) {
    return [i, ", "];
  }).concat(["and ", list[list.length - 1]]).flat();
}
function addDescription(resource) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (resource) {
    if (!Array.isArray(resource)) {
      resource = [resource];
    }
    if (Array.isArray(resource)) {
      resource = listCommas(resource.map(prependAsn)).join("");
    }
  }
  if (description && description !== "" && isNaN(description)) {
    return "".concat(resource, " (").concat(description, ")");
  } else {
    return resource;
  }
}
function roaListToString(data) {
  return data.map(function (roa) {
    return "<".concat(roa.prefix, ", ").concat(roa.asn, ", ").concat(roa.maxLength, ", ").concat(roa.ta, ">");
  }).join("; ");
}
function getObfuscatedEventSummary(context) {
  var _context$monitoredAsn, _context$monitoredAsn2, _context$monitoredAsn3;
  switch (context.type) {
    case "neighbors":
      return "A new peer of AS".concat((_context$monitoredAsn = context.monitoredAsn) !== null && _context$monitoredAsn !== void 0 ? _context$monitoredAsn : context.affected, " has been detected.");
    case "roa-diff":
      return "Some ROAs covering your resources have changed.";
    case "hijack":
      return "A hijack of ".concat((_context$monitoredAsn2 = context.monitoredAsn) !== null && _context$monitoredAsn2 !== void 0 ? _context$monitoredAsn2 : context.affected, " has been detected");
    case "visibility":
      return "One of your prefixes has been withdrawn and is no longer visible.";
    case "misconfiguration":
      return "".concat((_context$monitoredAsn3 = context.monitoredAsn) !== null && _context$monitoredAsn3 !== void 0 ? _context$monitoredAsn3 : context.affected, " is announcing a new prefix.");
    case "newprefix":
      return "".concat(context.monitoredAsn, " is announcing a new prefix.");
    case "roa-expire":
      return "One or more of your ROAs are expiring.";
    case "rpki-invalid":
      return "One of your prefixes is RPKI invalid.";
    case "rpki-unknown":
      return "One of your prefixes is RPKI unknown.";
    case "bogons":
      return "".concat(context.monitoredAsn, " is announcing the bogon prefix");
    default:
      return "A BGP alert of type ".concat(context.type, " is impacting ").concat(context.monitoredAsn ? "AS".concat(context.monitoredAsn) : context.affected, ".");
  }
}
function eventSummary(context, eventType) {
  var _context$extra, _extra$vrps, _context$extra2, _context$extra3, _context$extra4, _context$extra6, _context$extra7;
  var descriptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var describedPrefix = context !== null && context !== void 0 && context.prefix ? addDescription(context.prefix, descriptions[context.prefix]) : null;
  var describedNewPrefix = context !== null && context !== void 0 && context.newprefix ? addDescription(context.newprefix, descriptions[context.newprefix]) : null;
  switch (eventType) {
    case "obfuscated":
      return getObfuscatedEventSummary(context);
    case "grouped":
      return "A cluster of ".concat(context.subType, " events impacting multiple resources has been detected.");
    case "hijack":
      // checked
      if (_ipSub["default"].isEqualPrefix(context.newprefix, context.prefix)) {
        return "The prefix ".concat(_ipSub["default"].shortenPrefix(context.newprefix), " is announced by AS").concat(context.neworigin, ". Instead, it should be announced by ").concat(context.asn, ".");
      } else {
        return "The prefix ".concat(_ipSub["default"].shortenPrefix(context.newprefix), " is announced by AS").concat(context.neworigin, ". Instead, it should be ").concat(describedPrefix, " announced by ").concat(context.asn, ".");
      }
    case "misconfiguration":
      return "".concat(context.asn, " is announcing ").concat(_ipSub["default"].shortenPrefix(context.prefix), " but this prefix is not in the configured list of announced prefixes.");
    case "newprefix":
      return "AS".concat(context.neworigin, " is announcing ").concat(_ipSub["default"].shortenPrefix(context.newprefix), ", a more specific of ").concat(describedPrefix, ".");
    case "path":
      return "";
    case "instability-path":
      return "BGP Flapping for prefix ".concat(context.prefix, ". ").concat(context.pathChanges.length, " path changes in the last ").concat(context.rangeTime, " minutes.");
    case "ta-expire":
      return "Possible TA malfunction: ".concat(context.extra.expiredPercentage.toFixed(2), "% of the ROAs are expiring in ").concat(context.extra.ta.toUpperCase(), ".");
    case "ta-malfunction":
      return "Possible TA malfunction: ".concat(context.extra.disappearedPercentage.toFixed(2), "% of the ROAs disappeared from ").concat(context.extra.ta.toUpperCase(), ".");
    case "roa-diff":
      var maxRoaToShow = 3;
      var data = context === null || context === void 0 || (_context$extra = context.extra) === null || _context$extra === void 0 ? void 0 : _context$extra.diff;
      if (data) {
        var details = "";
        if (data.length <= maxRoaToShow) {
          details = data.slice(0, maxRoaToShow).join("; ");
        } else {
          var removedCount = data.filter(function (i) {
            return i.includes("removed");
          }).length;
          var addedCount = data.filter(function (i) {
            return i.includes("added");
          }).length;
          if (removedCount && addedCount) {
            details = "".concat(removedCount, " removed, ").concat(addedCount, " added.");
          } else if (removedCount) {
            details = "".concat(removedCount, " removed.");
          } else if (addedCount) {
            details = "".concat(addedCount, " added.");
          }
        }
        return "ROAs change detected: ".concat(details);
      } else {
        return "Some ROAs covering your resources have changed.";
      }
    case "roa-expire":
      var extra = context === null || context === void 0 ? void 0 : context.extra;
      var amount = extra === null || extra === void 0 || (_extra$vrps = extra.vrps) === null || _extra$vrps === void 0 ? void 0 : _extra$vrps.length;
      var lapse = Math.max(1, context.extra.roaExpirationHours);
      var unit = lapse === 1 ? "hour" : "hours";
      if (context !== null && context !== void 0 && (_context$extra2 = context.extra) !== null && _context$extra2 !== void 0 && _context$extra2.days) {
        lapse = Math.max(1, parseInt(context.extra.roaExpirationHours / 24));
        unit = lapse === 1 ? "day" : "days";
      }
      if (amount > 4) {
        return "".concat(amount, " ROAs will expire in less than ").concat(lapse, " ").concat(unit, ".");
      } else {
        var roa = amount > 1 ? "ROAs" : "ROA";
        return "The following ".concat(roa, " will expire in less than ").concat(lapse, " ").concat(unit, ": ").concat(roaListToString(extra.vrps), ".");
      }
    case "rpki-invalid":
      // checked
      return "The route ".concat(describedNewPrefix, " announced by AS").concat(context.neworigin[0], " is not RPKI valid.");
    case "rpki-disappear":
      return "The route ".concat(describedNewPrefix, " announced by AS").concat(context.neworigin[0], " is no longer covered by a ROA.");
    case "rpki-unknown":
      return "The route ".concat(describedNewPrefix, " announced by AS").concat(context.neworigin[0], " is not covered by a ROA.");
    case "visibility":
      return "The prefix ".concat(describedPrefix, " has been withdrawn. It is no longer visible from at least ").concat(context.peers, " feeders.");
    case "neighbors":
      // checked

      if (context.asn && context !== null && context !== void 0 && (_context$extra3 = context.extra) !== null && _context$extra3 !== void 0 && _context$extra3.side && context !== null && context !== void 0 && (_context$extra4 = context.extra) !== null && _context$extra4 !== void 0 && _context$extra4.neighbor) {
        var _context$extra5;
        var side = context.extra.side;
        if (((_context$extra5 = context.extra) === null || _context$extra5 === void 0 ? void 0 : _context$extra5.tag) === "tier1") {
          return "A new peer of ".concat(context.asn, " has been detected: AS").concat(context.extra.neighbor, ".");
        }
        return "A new ".concat(side, " of ").concat(context.asn, " has been detected: AS").concat(context.extra.neighbor, ".");
      } else {
        return context.summary; // for now this is good
      }
    case "bogons":
      var announcedBogon = context === null || context === void 0 || (_context$extra6 = context.extra) === null || _context$extra6 === void 0 ? void 0 : _context$extra6.prefix;
      var exactBogon = context === null || context === void 0 || (_context$extra7 = context.extra) === null || _context$extra7 === void 0 ? void 0 : _context$extra7.bogon;
      if (_ipSub["default"].isEqualPrefix(announcedBogon, exactBogon.prefix)) {
        return "".concat(context.asn, " is announcing the bogon prefix ").concat(_ipSub["default"].shortenPrefix(announcedBogon), " (").concat(exactBogon.description, ")");
      } else {
        return "".concat(context.asn, " is announcing the bogon prefix ").concat(_ipSub["default"].shortenPrefix(announcedBogon), " part of ").concat(exactBogon.prefix, " (").concat(exactBogon.description, ")");
      }
  }
}
function getNotificationUrl(baseURl, params) {
  if (!params) {
    return null;
  }
  var data = params.data,
    service = params.service,
    type = params.type,
    id = params.id;
  var getSegments = function getSegments() {
    switch (service) {
      case "generic":
        if (type === "log" && !!(data !== null && data !== void 0 && data.id) && !!(data !== null && data !== void 0 && data.fingerprint)) {
          return "/bgp/event/".concat(data.id, "/").concat(data.fingerprint);
        }
        if (type === "admin") {
          if (data.type === "instance") {
            return "/admin-actions/disabled-instance/".concat(id);
          }
          if (data.type === "resource") {
            return "/admin-actions/disabled-resource/".concat(id);
          }
          if (data.type === "ownership") {
            return "/admin-actions/account-disabled";
          }
        }
        break;
      case "bgp":
        if (type === "config-update") {
          return "/info/update/".concat(id);
        }
        if (type === "setup" && (data === null || data === void 0 ? void 0 : data.status) === "success") {
          return "/info/setup/".concat(id);
        }
        if (!!(data !== null && data !== void 0 && data.id) && !!(data !== null && data !== void 0 && data.fingerprint)) {
          return "/bgp/event/".concat(data.id, "/").concat(data.fingerprint);
        }
        break;
    }
    return "/notifications/".concat(id);
  };
  var path = getSegments();
  return path ? _brembo["default"].build(baseURl, {
    canonical: true,
    path: path
  }) : null;
}
function getSeverityText(number) {
  var _severities;
  return (_severities = severities[number - 1]) !== null && _severities !== void 0 ? _severities : severities[0];
}
function getSeverities() {
  return [].concat(severities);
}
function getGeofeedFileKey(inetnum) {
  var strInetnum = toRange(inetnum).join("-");
  var base = (0, _md["default"])(strInetnum).slice(0, 5);
  var split = strInetnum.includes(".") ? "." : ":";
  return "".concat(base, "_").concat(strInetnum.split(split)[0], ".csv");
}
function getFirst(list) {
  if (list !== null && list !== void 0 && list.length) {
    return list[0];
  } else {
    return null;
  }
}
function getLast(list) {
  if (list !== null && list !== void 0 && list.length) {
    return list[list.length - 1];
  } else {
    return null;
  }
}
function toRange(prefixOrRange) {
  if (_ipSub["default"].isValidPrefix(prefixOrRange)) {
    return _ipSub["default"].cidrToRange(prefixOrRange);
  } else if (Array.isArray(prefixOrRange)) {
    return prefixOrRange;
  } else if (prefixOrRange.includes("-")) {
    // Range
    return prefixOrRange.split("-").map(function (i) {
      return i.trim();
    });
  }
}
function cleanRirString(rir) {
  rir = rir.toUpperCase();
  var _iterator2 = _createForOfIteratorHelper(_validationUtil.rirs),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var r = _step2.value;
      if (rir.includes(r)) {
        return r;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return null;
}
function renderDate(momentTime) {
  var d = (0, _moment["default"])(momentTime).utc();
  return d.format("YYYY-MM-DD HH:mm") + " UTC";
}
function roundToSeconds(date, roundToSeconds) {
  date = date !== null && date !== void 0 ? date : (0, _moment["default"])();
  return Math.floor((0, _moment["default"])(date).utc().unix() / roundToSeconds) * roundToSeconds;
}
function indexComponent() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 ? arguments[1] : undefined;
  var out = {};
  var _iterator3 = _createForOfIteratorHelper(components),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var component = _step3.value;
      var id = component[field];
      out[id] = component;
      delete component[field];
      delete component.label;
      component.id = id;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return out;
}
function indexArray(arr, field) {
  var index = {};
  var _iterator4 = _createForOfIteratorHelper(arr),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var a = _step4.value;
      index[a[field]] = a;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return index;
}
function intersectArray(arr1, arr2) {
  var setB = new Set(arr2);
  return unique(arr1).filter(function (x) {
    return setB.has(x);
  });
}
function toFirstLetterUppercase(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
function pruneDictionary(dict, keys) {
  var out = {};
  var _iterator5 = _createForOfIteratorHelper(keys),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var key = _step5.value;
      if (dict[key] !== undefined) {
        out[key] = dict[key];
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return out;
}
function getBgpMonitoringGroup(instance) {
  return "g-".concat(instance);
}
function indexArrayDuplicates(arr, fieldKey) {
  var index = {};
  var _iterator6 = _createForOfIteratorHelper(arr),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _index$key;
      var k = _step6.value;
      var key = k[fieldKey];
      index[key] = (_index$key = index[key]) !== null && _index$key !== void 0 ? _index$key : [];
      index[key].push(k);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return index;
}
function indexArrayValue(arr, fieldKey, fieldValue) {
  var index = {};
  var _iterator7 = _createForOfIteratorHelper(arr),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var a = _step7.value;
      index[a[fieldKey]] = a[fieldValue];
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return index;
}
function getPlanUpgradeUrl(baseUrl, instanceId, subToUpgradeId, min, redirect, equal, upgradeHash) {
  var category = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "bgp";
  return _brembo["default"].build(baseUrl, {
    canonical: true,
    path: ["billings", "plans", instanceId, category].concat(subToUpgradeId ? [subToUpgradeId] : []),
    params: {
      min: min,
      equal: equal,
      redirect: redirect,
      hash: upgradeHash
    }
  });
}
function unique(items) {
  return _toConsumableArray(new Set(items));
}
function splitArrayIntoChunks(arr) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (chunkSize === 0) {
    throw new Error("chunkSize cannot be 0");
  }
  var chunks = [];
  for (var i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
}
function noFail(promise) {
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return promise["catch"](function (error) {
    var _getGlobal;
    if (error && (log || (_getGlobal = getGlobal()) !== null && _getGlobal !== void 0 && _getGlobal.enableNoFailLog)) {
      console.log("No fail:", error);
    }
    return null;
  });
}
function delayedPromise(promiseCall, delay) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(promiseCall());
    }, delay);
  });
}
var _uniqueDelayedPromises = {};
function uniqueDelayedPromise(promiseCall, delay) {
  var _promiseCall$name;
  var id = (_promiseCall$name = promiseCall === null || promiseCall === void 0 ? void 0 : promiseCall.name) !== null && _promiseCall$name !== void 0 ? _promiseCall$name : "";
  return new Promise(function (resolve) {
    if (_uniqueDelayedPromises[id]) {
      clearTimeout(_uniqueDelayedPromises[id]);
    }
    _uniqueDelayedPromises[id] = setTimeout(function () {
      return resolve(promiseCall());
    }, delay);
  });
}
function removeNullables(dict) {
  var list = Object.keys(dict).map(function (key) {
    return {
      key: key,
      value: dict[key]
    };
  }).filter(function (i) {
    return i.value != null;
  });
  var out = {};
  var _iterator8 = _createForOfIteratorHelper(list),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _step8$value = _step8.value,
        key = _step8$value.key,
        value = _step8$value.value;
      out[key] = value;
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return out;
}
function toFirstUpperCase(str) {
  return "".concat(str[0].toUpperCase()).concat(str.slice(1));
}
function prependAsn(resource) {
  return (0, _validationUtil.bool)(_netValidations.validateAS, resource) || (0, _validationUtil.bool)(_validationUtil.validateAsFromString, resource) ? "AS".concat(resource.toString().replace("AS", "")) : resource;
}
function sumArrayItems(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}
function getVatPercentage(country) {
  var _EE$country;
  return (_EE$country = {
    "EE": 24
  }[country]) !== null && _EE$country !== void 0 ? _EE$country : 0;
}
function roundToDecimals(value) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var factor = Math.pow(10, digits);
  return Math.round(value * factor) / factor;
}
function prefixPayloadCreation(instanceId, parentPrefix, asn, params) {
  var _params$description, _params$tags;
  var ignore, ignoreMorespecifics, manualNewPrefix;
  if (asn) {
    ignore = false;
    ignoreMorespecifics = false;
    manualNewPrefix = false;
  } else if (parentPrefix && parentPrefix.manual === true) {
    ignore = false;
    ignoreMorespecifics = false;
    manualNewPrefix = true;
  } else {
    ignore = true;
    ignoreMorespecifics = true;
    manualNewPrefix = false;
  }
  return {
    instance: instanceId,
    active: true,
    description: (_params$description = params === null || params === void 0 ? void 0 : params.description) !== null && _params$description !== void 0 ? _params$description : null,
    type: "prefix",
    excludeMonitors: [],
    includeMonitors: [],
    asn: params.asns,
    prefix: _ipSub["default"].shortenPrefix(params.prefix),
    v4: _ipSub["default"].getAddressFamily(params.prefix) === 4,
    ignore: ignore,
    group: getBgpMonitoringGroup(instanceId),
    ignoreMorespecifics: ignoreMorespecifics,
    manual: manualNewPrefix,
    tags: (_params$tags = params === null || params === void 0 ? void 0 : params.tags) !== null && _params$tags !== void 0 ? _params$tags : []
  };
}
function processSuspensionReasons(shouldBeActive) {
  var reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var suspensionReason = arguments.length > 2 ? arguments[2] : undefined;
  (0, _validationUtil.validateSuspensionReason)(suspensionReason);
  var chain = {
    admin: ["eventLimitLight, eventLimit"]
  };
  var suspensionReasons;
  if (shouldBeActive) {
    suspensionReasons = reasons.filter(function (i) {
      var _chain$suspensionReas;
      return ![].concat(_toConsumableArray((_chain$suspensionReas = chain === null || chain === void 0 ? void 0 : chain[suspensionReason]) !== null && _chain$suspensionReas !== void 0 ? _chain$suspensionReas : []), [suspensionReason]).includes(i);
    });
  } else {
    suspensionReasons = unique([].concat(_toConsumableArray(reasons), [suspensionReason]));
  }
  var didItChange = reasons.length !== suspensionReasons.length;
  return {
    suspensionReasons: suspensionReasons,
    active: suspensionReasons.length === 0,
    lastActiveStatusChange: didItChange ? _moment["default"].utc().toDate() : undefined
  };
}
function hashStringToInt(string, digits) {
  digits = digits || 6;
  var m = Math.pow(10, digits + 1) - 1;
  var phi = Math.pow(10, digits) / 2 - 1;
  var n = 0;
  for (var i = 0; i < string.length; i++) {
    n = (n + phi * string.charCodeAt(i)) % m;
  }
  return n;
}
function conditionalPromise(condition) {
  var promise1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var promise2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (condition) {
    if (promise1) {
      return promise1();
    } else {
      return Promise.resolve();
    }
  } else {
    if (promise2) {
      return promise2();
    } else {
      return Promise.resolve();
    }
  }
}
function difference(dict1, dict2) {
  var keys1 = Object.keys(dict1);
  var keys2 = Object.keys(dict2);
  var intersection = intersectArray(keys1, keys2);
  var allKeys = unique([].concat(keys1, keys2));
  var out = {};
  var _iterator9 = _createForOfIteratorHelper(allKeys),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var key = _step9.value;
      if (!intersection.includes(key)) {
        var _dict1$key;
        out[key] = (_dict1$key = dict1[key]) !== null && _dict1$key !== void 0 ? _dict1$key : dict2[key];
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return out;
}
function isPromise(obj) {
  return obj instanceof Promise || obj !== null && typeof (obj === null || obj === void 0 ? void 0 : obj.then) === "function";
}
function promisify(func) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve, reject) {
    try {
      var out = func(data);
      if (isPromise(out)) {
        var _out$then;
        out === null || out === void 0 || (_out$then = out.then(resolve)) === null || _out$then === void 0 || _out$then["catch"](reject);
      } else {
        resolve(out);
      }
    } catch (error) {
      reject(error);
    }
  });
}
function convertIsoToEurostatCountryCode(country) {
  var _isoEurostatConversio;
  var isoEurostatConversions = {
    "GR": "EL",
    "GB": "UK"
  };
  return (_isoEurostatConversio = isoEurostatConversions[country]) !== null && _isoEurostatConversio !== void 0 ? _isoEurostatConversio : country;
}
function getGlobal() {
  return typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : Function("return this")();
}
function expandBgpAlert(event) {
  var _event$content$data, _event$content;
  var data = (_event$content$data = event === null || event === void 0 || (_event$content = event.content) === null || _event$content === void 0 ? void 0 : _event$content.data) !== null && _event$content$data !== void 0 ? _event$content$data : [];
  if (data.length > 0) {
    var index = [];
    var _iterator0 = _createForOfIteratorHelper(data),
      _step0;
    try {
      for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
        var item = _step0.value;
        var matchedRule = item === null || item === void 0 ? void 0 : item.matchedRule;
        if (matchedRule !== null && matchedRule !== void 0 && matchedRule._f) {
          if (Object.keys(matchedRule).length > 1) {
            var _matchedRule$_f, _index$_matchedRule$_;
            item.matchedRule = _objectSpread({}, matchedRule);
            delete item.matchedRule._f;
            (_index$_matchedRule$_ = index[_matchedRule$_f = matchedRule._f]) !== null && _index$_matchedRule$_ !== void 0 ? _index$_matchedRule$_ : index[_matchedRule$_f] = _objectSpread({}, item.matchedRule);
          } else {
            item.matchedRule = _objectSpread({}, index[matchedRule._f]);
          }
        }
      }
    } catch (err) {
      _iterator0.e(err);
    } finally {
      _iterator0.f();
    }
  }
}
function summarizeBgpAlert(event) {
  var _event$content$data2, _event$content2;
  var data = (_event$content$data2 = event === null || event === void 0 || (_event$content2 = event.content) === null || _event$content2 === void 0 ? void 0 : _event$content2.data) !== null && _event$content$data2 !== void 0 ? _event$content$data2 : [];
  if (data.length > 0) {
    var index = {};
    var _iterator1 = _createForOfIteratorHelper(data),
      _step1;
    try {
      for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
        var item = _step1.value;
        var matchedRule = item === null || item === void 0 ? void 0 : item.matchedRule;
        if (!matchedRule._f) {
          var _f = (0, _objectFingerprint["default"])(matchedRule);
          if (index[_f]) {
            item.matchedRule = {
              _f: _f
            };
          } else {
            index[_f] = true;
            item.matchedRule = _objectSpread(_objectSpread({}, item.matchedRule), {}, {
              _f: _f
            });
          }
        }
      }
    } catch (err) {
      _iterator1.e(err);
    } finally {
      _iterator1.f();
    }
  }
}
function getNormalText(input) {
  return Array.from(input.normalize("NFD")).filter(function (_char) {
    return !/(?:[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B55\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0D81\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDD69-\uDD6D\uDEAB\uDEAC\uDEFC-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74\uDFBB-\uDFC0\uDFCE\uDFD0\uDFD2\uDFE1\uDFE2]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42\uDF5A]|\uD80D[\uDC40\uDC47-\uDC55]|\uD818[\uDD1E-\uDD29\uDD2D-\uDD2F]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF\uDDEE\uDDEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])/.test(_char);
  }) // remove non-spacing marks (accents)
  .join("");
}
function diversifySortByField(arr, field) {
  var freq = {};
  var buckets = [];

  // Group by key
  arr.forEach(function (obj, i) {
    var key = obj[field];
    if (!freq[key]) {
      freq[key] = [];
    }
    freq[key].push({
      obj: obj,
      i: i
    });
  });

  // Create array of queues (preserve original order)
  for (var key in freq) {
    buckets.push(_toConsumableArray(freq[key]));
  }
  var result = [];
  while (buckets.length > 0) {
    // Sort buckets by remaining size (desc), then by first appearance (stable)
    buckets.sort(function (a, b) {
      return b.length - a.length || a[0].i - b[0].i;
    });
    for (var i = 0; i < buckets.length;) {
      var item = buckets[i].shift();
      result.push(item.obj);
      if (buckets[i].length === 0) {
        buckets.splice(i, 1);
      } else {
        i++;
      }
    }
  }
  return result;
}